import { apiService } from './api.service';

export type ChatSystemMessage = {
  content: string;
  helperText?: string | null;
  quickReplies?: string[];
};

export type ChatSlotResponse = {
  systemMessage?: ChatSystemMessage;
  stepKey?: string;
  slotKey?: string;
  completedStepKey?: string;
  inputType?: 'short_text' | 'long_text' | 'yes_no' | 'single_select' | 'multi_select';
  options?: { value: string; label: string }[];
  done?: boolean;
};

export const chatService = {
  async bootstrap(sessionId: string, payload?: { language?: string }): Promise<ChatSlotResponse> {
    const response = await apiService.chatBootstrap(sessionId, payload);
    return (response.data || response) as ChatSlotResponse;
  },

  async getMessages(sessionId: string, limit: number = 200): Promise<any[]> {
    const response = await apiService.chatMessages(sessionId, limit);
    return response?.messages || [];
  },

  async next(
    sessionId: string,
    payload: { userMessage?: string; quickReplyValue?: string; language?: string }
  ): Promise<ChatSlotResponse> {
    const response = await apiService.chatNext(sessionId, payload);
    return (response.data || response) as ChatSlotResponse;
  },

  async rollback(
    sessionId: string,
    payload: { targetStepKey: string; needsReviewSlots?: string[]; consumeRollback?: boolean }
  ): Promise<void> {
    await apiService.chatRollback(sessionId, payload);
  },
};

export default chatService;
